import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { actions } from '../../modules/Actions';

export interface CustomCountProps {
  filterKey: string;
  countNum: { [key: string]: string | number };
}

export interface customCountListState {
  customCountList: CustomCountProps[];
}

export const initialState: customCountListState = {
  customCountList: [],
};

export const customCountListReducer = reducerWithInitialState(initialState).case(
  actions.fetchCustomCountList,
  (state: customCountListState, payload: customCountListState) => {
    return payload;
  }
);
